import { createSearchParams, useNavigate, useParams } from 'react-router-dom'

import Button from '../common/Button'
import InlineCheckbox from '../common/InlineCheckbox'
import InputText from '../common/InputText'
import TextArea from '../common/TextArea'
import { useContext, useEffect, useState } from 'react'
import { NavContext } from '../../context/global_context'
import { getLocalStorageData } from '../../utils/LocalStorageAccess'
import { getRequest, postRequest, putRequest } from '../../services/base'
import SelectInput from '../common/SelectInput'
import { MAKE_ID } from '../../constants/common'
import { getSessionStorageData } from '../../utils/SessionStorage'
import { Card, Flex, Form } from 'antd'
import { useVehicles } from '../../context/vehicle_context'

const VehicleForm = (props) => {
  const { vehicleDetails, setVehicleDetails } = props
  const { vehicle } = useParams()
  const [value, dispatch] = useContext(NavContext)
  const [optionCodes, setOptionCodes] = useState([])
  const navigate = useNavigate()
  const [form] = Form.useForm()
  const { selectedVehicleName } = useVehicles()
  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  useEffect(() => {
    dispatch({
      type: 'header',
      data: {
        header: 'Admin Tools',
        sub_header: selectedVehicleName
          ? `Vehicle List / ${selectedVehicleName} / Edit Vehicle`
          : 'Vehicle List / Create New Vehicle',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        vehicle: vehicle,
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
    getsetOptionCodes()
    setDetailsInState('make', getLocalStorageData(MAKE_ID))
  }, [])

  const saveVehicle = async (values) => {
    const data = { ...values }

    ;['make', 'model', 'year', 'phase'].forEach((key) => {
      if (typeof data?.[key] === 'string') {
        data[key] = data[key].toLowerCase()
      }
    })

    delete data.vin_dependent_tags

    if (typeof vehicleDetails?.vin_dependent_tags === 'object') {
      data.vin_dependent_tags = JSON.stringify(
        vehicleDetails?.vin_dependent_tags
      )
    } else {
      data.vin_dependent_tags = JSON.stringify(
        vehicleDetails?.vin_dependent_tags
          ? vehicleDetails?.vin_dependent_tags.split(',')
          : ''
      )
    }

    // convert to FormData
    const formData = new FormData()
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value)
      }
    })
    // console.log([...formData.entries()])

    if (vehicle) {
      let res = await putRequest(
        `/api/vehicles/update_vehicle_details/${vehicle}/`,
        formData
      )
      navigate(vehicle_redirect_url)
    } else {
      let res = await postRequest(
        `/api/vehicles/save_vehicle_details/`,
        formData
      )
      navigate(vehicle_redirect_url)
    }
  }

  const setDetailsInState = (name, value) => {
    setVehicleDetails({ ...vehicleDetails, [`${name}`]: value })
  }

  const getsetOptionCodes = async () => {
    if (vehicle) {
      let res = await getRequest(
        `/api/option_codes/options/?vehicle=${vehicle}`
      )
      setOptionCodes(res.data)
    } else {
      setOptionCodes([])
    }
  }
  const getInitialValues = () => {
    return {
      make: vehicleDetails?.make,
      model: vehicleDetails?.model,
      year: vehicleDetails?.year,
      phase: vehicleDetails?.phase,
      make_description: vehicleDetails?.make_description,
      model_description: vehicleDetails?.model_description,
      default_option_code: vehicleDetails?.default_option_code?.toString(),
      tester_id: vehicleDetails?.tester_id,
      time_zone: vehicleDetails?.time_zone,
      company: vehicleDetails?.company,
      make_model_id: vehicleDetails?.make_model_id,
      model_year_sales_code: vehicleDetails?.model_year_sales_code,
      vin_dependent_tags: vehicleDetails?.vin_dependent_tags,
      svg_enabled: vehicleDetails?.svg_enabled,
      svg_stroke: vehicleDetails?.svg_stroke,
      svg_fill: vehicleDetails?.svg_fill,
      svg_resolution: vehicleDetails?.svg_resolution,
    }
  }
  useEffect(() => {
    form.setFieldsValue(getInitialValues())
  }, [vehicleDetails])

  return (
    <div className="vehicle-form">
      <Form
        id="vehicle-form-details"
        name="vehicle-form-details"
        form={form}
        layout="vertical"
        onFinish={saveVehicle}
      >
        <Card title="Basic Details" variant="outlined">
          <Flex wrap gap={16} style={{ paddingBottom: 16 }}>
            <InputText
              type="text"
              onChange={(value) => {
                setDetailsInState('make', value)
              }}
              label="Make"
              name="make"
              disabled={getLocalStorageData(MAKE_ID) ? true : false}
              wrapperClass="justify-items-evenly"
            />
            <InputText
              type="text"
              onChange={(value) => {
                setDetailsInState('model', value)
              }}
              label="Model"
              name="model"
              value={vehicleDetails?.model}
              wrapperClass="justify-items-evenly"
            />
            <InputText
              type="number"
              onChange={(value) => {
                setDetailsInState('year', value)
              }}
              label="Manufacturing Year"
              name="year"
              value={vehicleDetails?.year}
              wrapperClass="justify-items-evenly"
            />
            <InputText
              type="text"
              onChange={(value) => {
                setDetailsInState('phase', value)
              }}
              label="Phase"
              name="phase"
              value={vehicleDetails?.phase}
              wrapperClass="justify-items-evenly"
            />
          </Flex>
          <Flex wrap gap={16} style={{ paddingBottom: 16 }}>
            <InputText
              type="text"
              onChange={(value) => {
                setDetailsInState('make_description', value)
              }}
              label="Make Description"
              name="make_description"
              value={vehicleDetails?.make_description}
              isRequired={false}
              wrapperClass="justify-items-evenly"
            />
            <InputText
              type="text"
              onChange={(value) => {
                setDetailsInState('model_description', value)
              }}
              label="Model Description"
              name="model_description"
              value={vehicleDetails?.model_description}
              isRequired={false}
              wrapperClass="justify-items-evenly"
            />
            <SelectInput
              name="default_option_code"
              label="Default Options Code"
              options={optionCodes}
              isRequired={false}
              wrapperClass="justify-items-evenly"
              onChange={(option) => {
                setDetailsInState('default_option_code_data', option)
                setDetailsInState('default_option_code', option?.value)
              }}
            />
            <InputText
              type="text"
              onChange={(value) => {
                setDetailsInState('tester_id', value)
              }}
              label="Tester Id"
              name="tester_id"
              value={vehicleDetails?.tester_id}
              isRequired={true}
              wrapperClass="justify-items-evenly"
            />
          </Flex>
        </Card>
        <Card title="Advanced Details" variant="outlined">
          <Flex wrap gap={16} style={{ paddingBottom: 16 }}>
            <InputText
              type="text"
              onChange={(value) => {
                setDetailsInState('time_zone', value)
              }}
              label="Time Zone"
              name="time_zone"
              value={vehicleDetails?.time_zone}
              wrapperClass="justify-items-evenly"
            />
            <InputText
              type="text"
              onChange={(value) => {
                setDetailsInState('company', value)
              }}
              label="Company Details"
              name="company"
              value={vehicleDetails?.company}
              wrapperClass="justify-items-evenly"
            />
            <InputText
              type="number"
              onChange={(value) => {
                setDetailsInState('make_model_id', value)
              }}
              label="Make Model Id"
              name="make_model_id"
              value={vehicleDetails?.make_model_id}
              wrapperClass="justify-items-evenly"
            />
            <InputText
              type="text"
              onChange={(value) => {
                setDetailsInState('model_year_sales_code', value)
              }}
              label="Model Year Sales Code"
              name="model_year_sales_code"
              value={vehicleDetails?.model_year_sales_code}
              isRequired={false}
              wrapperClass="justify-items-evenly"
            />
          </Flex>
          <Flex wrap gap={16} style={{ paddingBottom: 16 }}>
            <TextArea
              onChange={(value) => {
                setDetailsInState('vin_dependent_tags', value)
              }}
              label="Vin Dependent Tags"
              name="vin_dependent_tags"
              placeholder="REAR PARK LAMPS ON"
              value={vehicleDetails?.vin_dependent_tags}
              wrapperClass="justify-items-evenly"
              rows={1}
              isRequired={false}
            />
          </Flex>
        </Card>
        <Card title="Vehicle SVG Details" variant="outlined">
          <Flex wrap gap={16} style={{ paddingBottom: 16 }}>
            <InlineCheckbox
              onChange={(value) => {
                setDetailsInState('svg_enabled', value)
              }}
              legend="SVG Status"
              label="Available"
              name="svg_enabled"
              value={vehicleDetails?.svg_enabled}
              wrapperClass="justify-items-evenly"
            />
            <InputText
              type="text"
              onChange={(value) => {
                setDetailsInState('svg_stroke', value)
              }}
              label="SVG Stroke"
              name="svg_stroke"
              value={vehicleDetails?.svg_stroke}
              wrapperClass="justify-items-evenly"
            />
            <InputText
              type="text"
              onChange={(value) => {
                setDetailsInState('svg_fill', value)
              }}
              label="SVG Fill"
              name="svg_fill"
              value={vehicleDetails?.svg_fill}
              wrapperClass="justify-items-evenly"
            />
            <InputText
              type="text"
              onChange={(value) => {
                setDetailsInState('svg_resolution', value)
              }}
              label="SVG Resolution"
              name="svg_resolution"
              value={vehicleDetails?.svg_resolution}
              wrapperClass="justify-items-evenly"
            />
          </Flex>
        </Card>
        <Button type="primary" htmlType="submit">
          Save Vehicle Details
        </Button>
      </Form>
    </div>
  )
}

export default VehicleForm
